import {RegularGameEventTemplateAnimationSetModel} from "../../templates/regular-game-event-template-animation-set-model";

export class RedCardAnimationSetModel extends RegularGameEventTemplateAnimationSetModel {}